<template>
  <div class="c-sleep-dna">
      <div v-for="(number, i) in dna" :key="i" class="c-sleep-dna--dot" :class="['c-sleep-dna--dot' + number]"></div>
  </div>
</template>

<script>
import {getSleepDnaFromMeasurement} from "@/utils/utils.js";

export default {
    name: "SleepDNA",
    props : {
        "result": {
            required: true, 
            type:Object
        }
    },

    computed: {
        dna() {
            return getSleepDnaFromMeasurement(this.result.BaseLevels);
        }
    }
};
</script>

<style scoped lang="scss">
    .c-sleep-dna {
        position: relative;
        display: flex;
        justify-content: space-between;

        $size : 6%;
        &--dot {
            position: relative;
            display : inline-block;
            width : $size;
            padding-bottom: $size;
            border-radius:50%;
            
            $margin : .5rem;
            &1 {
                background : $color-green;
            }
            &2 {
                background : $color-yellow;
                top:$margin;
            }
            &3 {
                background : $color-red;
                top: #{$margin * 2};
            }
            &4 {
                background : $color-blue;
                top: #{$margin * 3};
            }
        }
    }
    
</style>

